import React from "react";
import styled from "styled-components";
import { Box } from "@mui/material";

const StyledScrollableContent: any = styled(Box)`
  overflow-y: auto;
  max-height: calc(100vh - 130px);
  margin-top: 60px;
`;

interface ContentSubHeaderProps {
  children: React.ReactNode;
}

const ContentSubHeader: React.FC<ContentSubHeaderProps> = ({ children }) => {
  return (
    <StyledScrollableContent sx={{ px: 1, py: 1 }}>
      {children}
    </StyledScrollableContent>
  );
};

export default ContentSubHeader;
